import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {RiskFactorsValidExpands, getRiskFactors} from '../../../../../../../actions/RiskFactor/riskfactoractions';
import {getRisks} from '../../../../../../../actions/Risk/riskactions';
import {getRiskFactorGroups} from '../../../../../../../selectors/ISA315/selectors';
import Loader from '../../../../../LoadingIndicator/LoadingIndicator';
import {useOverrideLabels} from '../../../../../../Main/Forms/Utilities/OverrideLabelsProvider';
import RelateRiskFactorHeaderListItem from './RelateRiskFactorHeaderListItem';
import { useAresUrlParameters, useSelectedStEntityId } from '../../../../../../../util/Ares/customHooks';
import { getTaskDocumentByDocumentId } from '../../../../../../../selectors/Ares/selectors';
import { isNullOrUndefined } from '../../../../../../../util/utils';

function RelateRiskFactorHeaderList({engagementId, bodyId, isDisabled}) {
	const dispatch = useDispatch();
	const {labels} = useOverrideLabels();
	const [selectedStEntityId] = useSelectedStEntityId();
	const [isLoading, setIsLoading] = useState(false);
	const {documentId} = useAresUrlParameters();
	const document =  useSelector((state) => getTaskDocumentByDocumentId(state, documentId));

	useEffect(() => {
		setIsLoading(true);
		setTimeout(() => {
			Promise.all([
				dispatch(
					getRiskFactors(
						engagementId,
						{
							expand: RiskFactorsValidExpands.formHeaders,
							filterMultiEntityIds: selectedStEntityId
								? selectedStEntityId
								: !isNullOrUndefined(document?.stEntityId)
								? document.stEntityId
								: undefined
						},
						{bodyId}
					)
				),
				dispatch(getRisks(engagementId, {pageSize: -1}))
			]).finally(() => {
				setIsLoading(false);
			});
		}, 175);
	}, []);

	const riskFactorHeaderGroups = useSelector(getRiskFactorGroups);

	return (
		<StyledRelateRiskFactorHeaderList className="StyledRelateRiskFactorHeaderList">
			{isLoading ? (
				<Loader fullscreen view="inlineView" show={isLoading} />
			) : riskFactorHeaderGroups.length > 0 ? (
				riskFactorHeaderGroups.map((header) => (
					<RelateRiskFactorHeaderListItem
						key={header.formHeaderId}
						engagementId={engagementId}
						headerId={header.formHeaderId}
						headerName={header.formHeaderTitle}
						bodyId={bodyId}
						riskFactorsList={header.riskFactorsList}
						isDisabled={isDisabled}
					/>
				))
			) : (
				<section className="empty-template">
					<span className="no-risks">{labels.noRiskFactors}</span>
				</section>
			)}
		</StyledRelateRiskFactorHeaderList>
	);
}

RelateRiskFactorHeaderList.propTypes = {
	engagementId: PropTypes.number,
	documentId: PropTypes.string,
	bodyId: PropTypes.number
};

const StyledRelateRiskFactorHeaderList = styled.section`
	.empty-template {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: default;
		.no-risks {
			color: var(--neutrals-700);
			font-size: var(--px-16);
			padding: var(--px-20) 0;
		}
	}
`;

export default RelateRiskFactorHeaderList;
